import React from 'react';

export const SplashScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white">
        <div className="animate-pulse flex flex-col items-center">
            {/* Authentic Logo */}
            <img 
                src="/logo.png" 
                alt="Speedlink Logo" 
                className="w-58 h-28 object-contain mb-6 drop-shadow-xl"
            />
            
        </div>
        <div className="mt-12 w-48 h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div className="h-full bg-indigo-600 animate-[loading_1.5s_ease-in-out_infinite]"></div>
        </div>
        <style>{`
            @keyframes loading {
                0% { width: 0%; margin-left: 0; }
                50% { width: 100%; margin-left: 0; }
                100% { width: 0%; margin-left: 100%; }
            }
        `}</style>
    </div>
  );
};